import React from "react";
import "./DarkEffect.css"

function DarkEffect(props) {
  return <div className="DarkEffect"></div>;
}

export default DarkEffect;
